import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const LinksTitle = styled.div`
  font-size: 20px;
  font-family: AvenirBold;
  font-weight: 500;
  padding-top: 10px;
  padding-bottom: 10px;
  line-height: 27px;
`;
const TopBorder = styled.div`
  width: 35px;
  height: 4px;
  background: #febb39;
`;
const LinksWrapper = styled.div`
  padding: 4px 0px;
  font-weight: 300;
  margin: 7px 0px;
`;

const LinkDiv = styled(Link)`
  :hover {
    cursor: pointer;
  }
`;
const ExternalLinkDiv = styled.div`
  a {
    color: white;
  }
  a:hover {
    text-decoration: none;
  }
`;
// , { title, links, id, test2 }
const FooterLinks = ({ title, links, id, updateSelectOption }) => (
  <div>
    <TopBorder />
    <LinksTitle>{title}</LinksTitle>
    {links.map((link, index) => {
      return (
        <LinksWrapper key={index}>
          {link.pageTitle !== 'Careers' && (
            <LinkDiv
              to={link.pageLink}
              // to={link.pageLink + "/" + link.id}
              state={{ selected: link.id }}
              style={{
                color: `white`,
                textDecoration: `none`
              }}
              onClick={() => {
                localStorage.setItem('selectedOption', link.id);
                updateSelectOption(link.id);
              }}>
              {link.pageTitle}
            </LinkDiv>
          )}
          {link.pageTitle === 'Careers' && (
            <ExternalLinkDiv>
              <a
                target='_blank'
                href='https://sites.google.com/a/werplay.com/careers/'>
                Careers
              </a>
            </ExternalLinkDiv>
          )}
        </LinksWrapper>
      );
    })}
  </div>
);

FooterLinks.propTypes = {
  title: PropTypes.string,
  links: PropTypes.array
};

FooterLinks.defaultProps = {
  title: '',
  links: [{ pageTitle: '', pageLink: '' }]
};

export { FooterLinks };
